import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO54 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK005-4.jpg"
      title="Reserved avatar"
      alt="Reserved avatar"
    />
  )
}

export default ImageMO54
